import { render, staticRenderFns } from "./LECO_Header.vue?vue&type=template&id=4a7187d2"
import script from "./LECO_Header.vue?vue&type=script&lang=js"
export * from "./LECO_Header.vue?vue&type=script&lang=js"
import style0 from "./LECO_Header.vue?vue&type=style&index=0&id=4a7187d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports